<h4>Nadmorska visina</h4>
<ngx-charts-line-chart
  [view]="[700, 300]"
  [results]="altitudeData()"
  [xAxis]="true"
  [yAxis]="true"
  [xAxisLabel]="'Vrijeme'"
  [yAxisLabel]="'Nadmorska visina (m)'"
  [yAxisTickFormatting]="formatAltitudeTick"
  [autoScale]="true"
  [legend]="false"
  [timeline]="true"
  [scheme]="'ocean'"
  [gradient]="true"
  >
</ngx-charts-line-chart>

<h4>Brzina</h4>
<ngx-charts-line-chart
  [view]="[700, 300]"
  [results]="speedData()"
  [xAxis]="true"
  [yAxis]="true"
  [xAxisLabel]="'Vrijeme'"
  [yAxisLabel]="'Brzina'"
  [yAxisTickFormatting]="formatSpeedTick"
  [autoScale]="true"
  [legend]="false"
  [timeline]="true"
  [scheme]="'cool'"
  [gradient]="true"
  >
</ngx-charts-line-chart>
